import styled from 'styled-components';
import { COLOR_ORANGE } from '../../assets/styles/colors';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  .left-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .back-to-faq {
      font-size: 18px;
      font-weight: bold;
      color: ${COLOR_ORANGE};
      display: flex;
      align-items: center;
      border: none;
      padding: 0px;
      background: none;
      &:hover {
        text-decoration: none;
      }
      svg {
        height: 16px;
        width: 16px;
        margin-right: 8px;
      }
    }
    &--main-headline {
    }
  }
`;
